import AbstractValueRow from "./AbstractValueRow.js";

/**
 * Static rows are only used to represent rows from legacy condensed reports.
 * Each row contains the column values.
 *
 * @param {decimal[]} [spec.values] - Static column values of the row.
 * @param {boolean} [spec.isSum] - Row is a sum calculation result.
 * Is used to determine if the row should be displayed as heading.
 */
class StaticReportRow extends AbstractValueRow {
	constructor({ values = [], isSum = false } = {}) {
		super(...arguments);
		this._values = values;
		this._isSum = isSum;
	}

	accept(visitor) {
		return visitor.visitStaticReportRow(this);
	}

	isVisibleWhenNoData() {
		return true;
	}

	canBeUsedInFormulas() {
		return false;
	}

	canBeCalculated() {
		return true;
	}

	isSum() {
		return this._isSum;
	}

	getStyle() {
		return this.isSum() ? "heading" : "text";
	}

	getValue(column) {
		const columnIndex = this._report.getColumns().indexOf(column);
		return this._values[columnIndex];
	}

	static getType() {
		return "StaticReportRow";
	}
}

export default StaticReportRow;
